module.exports = __webpack_public_path__ + "fwd_logo_orange_bg.3ay4U.jpg";